import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { withConfiguration } from './utils';
import Loading from './components/Loading';

const SharedProduct = lazy(() => import('./components/SharedProduct'));
const PassengerInfo = lazy(() => import('./views/PassengerInfo'));
const PassengersManagement = lazy(() => import('./views/PassengersManagement'))
const FlightsSearch = lazy(() => import('./components/Flights/Search'))
const FlightsResults = lazy(() => import('./components/Flights/Results'))
const HotelsSearch = lazy(() => import('./components/Hotels/Search'))
const HotelsResults = lazy(() => import('./components/Hotels/Results'))
const Payment = lazy(() => import('components/Payment'))
const Error = lazy(() => import('./views/Error/index'))
const Success = lazy(() => import('./views/Success/index'))
const PaymentCardForm = lazy(() => import('./views/PaymentCardForm/index'))
const PaymentCardFormSuccess = lazy(() => import('./views/PaymentCardFormSuccess/index'))
// const ButtonsAction = lazy(() => import('./components/ButtonsAction/index.jsx'));


const Nixi1 = props => (
    <Suspense fallback={<Loading plane={true} />}>

        {/* Payment Booking */}
        <Route path="/payment-card/:lang/:token" render={({ match }) => <PaymentCardForm {...props} lang={match.params.lang} token={match.params.token} />} />
        <Route path="/payment-card/success" exact render={() => <PaymentCardFormSuccess {...props} lang={props.location.search.slice(6, 8)} />} />

        {/* Payment */}
        <Route path="/payment/:lang/:token" render={({ match }) => <Payment {...props} lang={match.params.lang} token={match.params.token} insurance={match.params.insurance} />} />
        <Route path="/payment/success" exact render={() => <Success {...props} lang={props.location.search.slice(6, 8)} />} />

        <Route path="/error" exact render={() => <Error {...props} lang={props.location.search.slice(6, 8)} />} />

        {/* Buttons Action */}
        {/* <Route path="/:companyName/b" exact render={() => <ButtonsAction {...props}/> }/> */}

        <Route path="/:webview/search" exact render={() => <FlightsSearch {...props} />} />

        {/* Flights */}
        <Route path="/:webview/flights" exact render={() => <FlightsSearch {...props} />} />
        <Route path="/:webview/flights/results" exact render={() => <FlightsResults {...props} />} />
        <Route path="/:webview/flights/info" exact render={() => <PassengerInfo {...props} />} />
        <Route path="/:webview/flights/share" exact render={() => <SharedProduct {...props} />} />

        {/* Hotels */}
        <Route path="/:webview/hotels" exact render={() => <HotelsSearch {...props} />} />
        <Route path="/:webview/hotels/results" exact render={() => <HotelsResults {...props} />} />
        <Route path="/:webview/hotels/info" exact render={() => <PassengerInfo {...props} />} />
        <Route path="/:webview/hotels/share" exact render={() => <SharedProduct {...props} />} />
        <Route path="/:webview/passengers" exact render={() => <PassengersManagement {...props} />} />
    </Suspense>
)

const Nixi1WithConfig = routerProps => withConfiguration(routerProps)(Nixi1)

const Routes = () => (
    <BrowserRouter>
        <Route path="/" component={Nixi1WithConfig} />
    </BrowserRouter>
)

export default Routes
